import keyBy from 'lodash/keyBy';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import ErrorPage from 'app/components/ErrorPage';
import {
  MOCK_BROWSE_HOME_PAGE_INDEX,
  MOCK_BROWSE_HOME_PAGE_INDEX_LOCAL_STORAGE_KEY
} from 'app/constants/admin/browse/home';
import { HTTP_STATUS_CODE } from 'app/constants/ErrorConstants';
import { hasAdminPermissions } from 'app/helpers/admin/browse/categories';
import { cleanBrowseHomePage } from 'app/helpers/admin/browse/home';
import { selectCurrentUser } from 'app/selectors/AuthSelector';
import AdminBrowseHomePage from './AdminBrowseHomePage';

const fetchBrowseHomePages = () => {
  let storedBrowseHomePageIndex = JSON.parse(localStorage.getItem(MOCK_BROWSE_HOME_PAGE_INDEX_LOCAL_STORAGE_KEY));

  if (!storedBrowseHomePageIndex) {
    storedBrowseHomePageIndex = MOCK_BROWSE_HOME_PAGE_INDEX;

    localStorage.setItem(MOCK_BROWSE_HOME_PAGE_INDEX_LOCAL_STORAGE_KEY, JSON.stringify(storedBrowseHomePageIndex));
  }

  const browseHomePages = Object.values(storedBrowseHomePageIndex).map(cleanBrowseHomePage);

  return new Promise(resolve => {
    setTimeout(() => {
      resolve(browseHomePages);
    }, 1000);
  });
};

const upsertBrowseHomePages = browseHomePages => {
  const newBrowseHomePageIndex = keyBy(browseHomePages, 'browseHomePageId');

  window.localStorage.setItem(MOCK_BROWSE_HOME_PAGE_INDEX_LOCAL_STORAGE_KEY, JSON.stringify(newBrowseHomePageIndex));

  return new Promise(resolve => {
    setTimeout(() => {
      resolve(Object.values(newBrowseHomePageIndex));
    }, 1000);
  });
};

// eslint-disable-next-line no-unused-vars
const AdminBrowseHomePageContainer = ({ basePageRoute }) => {
  const currentUser = useSelector(selectCurrentUser);

  const [state, setState] = useState({
    browseHomePages: [],
    isLoading: true,
    isSaving: false
  });

  const { browseHomePages, isLoading, isSaving } = state;

  useEffect(() => {
    fetchBrowseHomePages()
      .then(fetchedBrowseHomePages => {
        setState(prevState => {
          return {
            ...prevState,
            browseHomePages: fetchedBrowseHomePages,
            isLoading: false
          };
        });
      })
      .catch(err => {
        // TODO: handle with toast notification
        /* eslint-disable-next-line no-console */
        console.error(err.message);
      });
  }, [setState]);

  const handleActivateBrowseHomePage = browseHomePageId => {
    const newBrowseHomePages = browseHomePages.map(browseHomePage => {
      return {
        ...browseHomePage,
        isActive: browseHomePage.browseHomePageId === browseHomePageId
      };
    });

    setState(prevState => {
      return {
        ...prevState,
        isSaving: true
      };
    });

    upsertBrowseHomePages(newBrowseHomePages)
      .then(upsertedBrowseHomePages => {
        setState(prevState => {
          return {
            ...prevState,
            browseHomePages: upsertedBrowseHomePages
          };
        });
      })
      .catch(err => {
        // TODO: handle with toast notification
        /* eslint-disable-next-line no-console */
        console.error(err.message);
      })
      .finally(() => {
        setState(prevState => {
          return {
            ...prevState,
            isSaving: false
          };
        });
      });
  };

  const handleDeleteBrowseHomePage = broseHomePageId => {
    const newBrowseHomePages = browseHomePages.filter(browseHomePage => {
      return browseHomePage.browseHomePageId !== broseHomePageId;
    });

    setState(prevState => {
      return {
        ...prevState,
        isSaving: true
      };
    });

    upsertBrowseHomePages(newBrowseHomePages)
      .then(upsertedBrowseHomePages => {
        setState(prevState => {
          return {
            ...prevState,
            browseHomePages: upsertedBrowseHomePages
          };
        });
      })
      .catch(err => {
        // TODO: handle with toast notification
        /* eslint-disable-next-line no-console */
        console.error(err.message);
      })
      .finally(() => {
        setState(prevState => {
          return {
            ...prevState,
            isSaving: false
          };
        });
      });
  };

  const canViewPage = hasAdminPermissions(currentUser);
  if (!canViewPage) {
    return <ErrorPage httpStatusCode={HTTP_STATUS_CODE.FORBIDDEN} />;
  }

  if (isLoading) {
    return <p>Loading...</p>;
  }

  return (
    <AdminBrowseHomePage
      browseHomePages={browseHomePages}
      isSaving={isSaving}
      onActivate={handleActivateBrowseHomePage}
      onDelete={handleDeleteBrowseHomePage}
    />
  );
};

AdminBrowseHomePageContainer.propTypes = {
  basePageRoute: PropTypes.string.isRequired
};

export default AdminBrowseHomePageContainer;
